import React, { FC, ReactNode, useEffect, useState, useRef, useLayoutEffect } from 'react';
import { motion } from 'framer-motion';

type Props = {
  showDecoration: boolean;
  children: ReactNode;
};

export const EditionDecoration: FC<Props> = ({ showDecoration, children }) => {
  if (!showDecoration) {
    return <>{children}</>;
  }

  const ref = useRef<HTMLDivElement>(null);

  const [mouse, setMouse] = useState({ x: 0, y: 0 });
  const [c, setC] = useState({ x: window.innerWidth / 2, y: window.innerHeight / 2 });
  const [tilt, setTilt] = useState({ x: 0, y: 0 });
  const [radius, setRadius] = useState(0);
  const [gRadius, setGRadius] = useState(0);

  let request = null;

  const handleMouseMovement = (e: MouseEvent) => {
    setMouse({ x: e.pageX, y: e.pageY });
  };

  const update = () => {
    const dx = mouse.x - c.x;
    const dy = mouse.y - c.y;

    const tiltX = -(dy / c.y);
    const tiltY = dx / c.x;

    setTilt({ x: tiltX, y: tiltY });
    setRadius(Math.sqrt(Math.pow(tiltX, 2) + Math.pow(tiltY, 2)) * 5);
    setGRadius((Math.atan2(tiltY, tiltX) * 180) / Math.PI);
  };

  useEffect(() => {
    window.addEventListener('pointermove', handleMouseMovement);

    return () => {
      window.removeEventListener('pointermove', handleMouseMovement);
    };
  }, []);

  useLayoutEffect(() => {
    update();
  }, [mouse.x, mouse.y]);

  useEffect(() => {
    const rect = ref.current?.getBoundingClientRect();

    if (ref && rect?.x) {
      setC({
        x: rect.x + rect.width / 2,
        y: rect.y + rect.height / 2,
      });
    }
  }, [ref]);

  const deltaX = (mouse.x / (window.innerWidth * 10)) * 100;
  const deltaY = (1 - mouse.x / (window.innerWidth * 10)) * 100;

  return (
    <motion.div
      animate={{
        transform: `perspective(300px) rotate3d(${tilt.x}, ${tilt.y}, 0, ${radius}deg)`,
      }}
    >
      <div className='nft-decoration' ref={ref}>
        <div
          className='nft-decoration__background'
          style={{
            background: `linear-gradient(${gRadius}deg, rgba(255, 255, 255, 0.05) ${deltaX}%, rgba(255, 255, 255, 0.15) ${deltaY}%)`,
          }}
        />
        {children}
      </div>
    </motion.div>
  );
};
